import React from "react";
import styles from "../App.module.css";

export default function CookiePreferencesButton() {
  const openCookiePreferences = (event) => {
    event.preventDefault();
    document.getElementById("termly-pref-trigger")?.click();
  };

  return (
    <button
      type="button"
      className={styles.CookiePreferencesLink}
      onClick={openCookiePreferences}
      aria-label="Consent Preferences"
      title="Consent Preferences"
    >
      {/* Cookie icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M21.95 10.993a1 1 0 0 0-.93-.687 3.003 3.003 0 0 1-2.799-2.445 1 1 0 0 0-.833-.833A3.003 3.003 0 0 1 14.994 4.2a1 1 0 0 0-.687-.93A10 10 0 1 0 21.95 10.993zM12 20a8 8 0 1 1 6.45-12.734 5.01 5.01 0 0 0 4.284 4.284A8.008 8.008 0 0 1 12 20z"/>
        <circle cx="9" cy="10" r="1.25"/>
        <circle cx="14" cy="15" r="1.25"/>
        <circle cx="10" cy="15.5" r=".75"/>
        <circle cx="15" cy="10.5" r=".75"/>
        <circle cx="12" cy="12.5" r=".75"/>
      </svg>
    </button>
  );
}
